
const TextArea = ({defaultValue, onBlur, onChange, hint, className, style}) => {

    const classN = "input" + (className ? " "+className : "");

    return (
        <textarea
            className={classN}
            defaultValue={defaultValue}
            onBlur={onBlur}
            onChange={onChange}
            placeholder={hint}
            style={style}
        />
    )
}

export default TextArea;
